import {
  nFormatter,
  createSeries,
  createSQL,
  seriesHead,
  appendAggregateValues,
  seriesDataItem,
  pickItem,
  isDateTransformation,
  highestModel,
  averageModel,
  missingValuesModel,
  resolve,
  getSeriesColors,
  extractColors,
  createFilter
} from "@/components/charts/common";

// import pluralize from 'pluralize';
import apexChartOptions from "@/common/apex-chart-defaults";

function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

function getItemText(parameters, key, value) {
  let node = resolve(key, parameters);
  if (!node) {
    return null;
  }
  for (let i = 0; i < node.items.length; i++) {
    const item = node.items[i];
    if (item[node.itemValue] == value) {
      if (typeof item.description != "undefined") {
        return item.description;
      } else {
        return item[node.itemText];
      }
    }
  }
  return null;
}

export async function hydrator(parameters, data, chart) {
  // alert("herte");
  console.log("chart.type", chart.type);
  chart.hasDialog = true;
  // return;
  // console.log("calling hydrator " + chart.id);
  //  data.valid = false;
  //  data.width = 500;
  //  data.height = 500;
  //  data.type = 'line';

  // console.log("bar chart hydrator");

  // Style
  chart.chartData.elevation = resolve("boxShadow.value", parameters);

  let options = {
    tooltip: { shared: false, intersect: true },
    markers: { size: 4 }
  };

  options.chart = { ...apexChartOptions };
  options.chart.events = { click: {} };
  // console.log("calling hydrator  2" + chart.id);
  // options.chart.events.click
  // options.chart.events.dataPointSelection
  chart.chartData.dateTransformations = [];
  chart.chartData.dateTransformation = {};
  options.chart.events.dataPointSelection = function (event, chartContext, config) {
    // console.log("config", config);
    // console.log("chartContext", chartContext);


    const activeColor = "rgb(255, 166, 0)";

    const el = event.target;
    const seriesIndex = parseInt(el.getAttribute("i"));
    const value = parseFloat(el.getAttribute("val"));
    const dataPointIndex = parseInt(el.getAttribute("j"));
    //  const seriesName = config.globals.seriesNames[seriesIndex];
    //  console.log(seriesName, dataPointIndex);
    const status = el.getAttribute("status");
    /**
    let firstFill = el.getAttribute("firstFill");
    // const status
    if(status == null) {
      // first click
      el.setAttribute("firstFill", el.getAttribute("fill"));
      el.setAttribute("fill", activeColor);
      el.setAttribute("status", "selected");
      el.setAttribute("opacity", 1);
    } else if(status == "selected") {
      // now des select
      el.setAttribute("fill", firstFill);
      el.setAttribute("status", "deselected");
    } else {
      // select
      el.setAttribute("fill", activeColor);
      el.setAttribute("status", "selected");
      el.setAttribute("opacity", 1);
    }**/

    // console.log(el.parentNode);
    // console.log(el.parentNode.children);

    // let children = el.parentNode.children;

    // j = group
    // i = item

    let gGroup = { ...series[config.seriesIndex] };
    let iItem = gGroup.data[config.dataPointIndex];
    gGroup.queryParameters = { ...gGroup.queryParameters };
    gGroup.data[config.dataPointIndex].selected = true;
    gGroup.selectedItem = iItem;




    // console.log("gGroup", gGroup);
    gGroup.color = el.getAttribute("fill");
    gGroup.colour = el.getAttribute("fill");
    chart.setActiveItem(gGroup);



    chart.chartData.dateTransformations = parameters.transformItemData.aggregates.filter(it => it.text.toLowerCase() != "none");

    // let iItems = gGroup.data;
    //  let iItems = [];
    //  series.forEach(sItem => {
    //    iItems.push(sItem.data[config.dataPointIndex]);
    //  });


    //  console.log("iItem", iItem);

    /**
      const children = el.parentNode.children;
      const selectedItems = [];
      for(let i = 0; i < children.length; i++) {
        const child = children[i];
        if(child.getAttribute("status") == "selected") {
          selectedItems.push(child);
        }
      }**/

    //
    //console.log("selectedItems", selectedItems);
    /**
    chart.chartData.expand.show = selectedItems.length ? true : false;
    let tI = pickItem(parameters.transformItemData);
    if(typeof tI.down != "undefined") {
      parameters.transformItemData.value = tI.down;
      hydrator(parameters, data, chart);
    } else if(typeof tI.up != "undefined") {
      parameters.transformItemData.value = tI.up;
      hydrator(parameters, data, chart);
    }**/

  };

  chart.activeItem = null;
  chart.dataSource = null;

  chart.loadActiveItem = async function (pFilters) {
    // return;
    if (typeof pFilters != "undefined") {
      chart.activeItem._filters = [...pFilters];
    }

    if (typeof pFilters == "undefined" && typeof chart.activeItem._filters != "undefined") {
      pFilters = [...chart.activeItem._filters];
    }


    const item = chart.activeItem;

    chart.subHeaders.forEach((item, i) => {
      item.position = i;
    });
    const l = chart.subHeaders.length;
    parameters.selectedColumns.value = JSON.stringify(chart.subHeaders);
    // console.log("parameters.selectedColumns.value", parameters.selectedColumns.value);

    let fields = '';
    let group = '';
    for (let i = 0; i < l; i++) {
      const column = chart.subHeaders[i];
      if (column.selected != true) {
        continue;
      }

      let agg = typeof column.aggregate != "undefined" && column.aggregate && typeof column.aggregate.function != "undefined" ? column.aggregate : { function: "field" };
      // console.log("agg", agg);
      // console.log("column", column);
      let agg2 = agg.function.replace("field", column.value);

      if (agg2 != column.value) {
        fields += agg2 + " AS " + column.value + ",";
        group += typeof agg.aggregateFunction != "undefined" && agg.aggregateFunction == true ? "" : agg2 + ",";
      } else {
        fields += column.value + ",";
        group += column.value + ",";
      }
    }

    if (fields.slice("-1") == ",") {
      fields = fields.slice(0, -1);
    }

    if (group.slice("-1") == ",") {
      group = group.slice(0, -1);
    }

    let sql = "SELECT " + fields + " FROM (" + item.queryParameters.fullQuery + ") AS _subQuery ";
    let filters = [...pFilters];
    filters = removeDuplicates(filters, 'field');
    // filters.push()


    /**
        filters.push({
          field: item.queryParameters.group,
          operator: '=',
          value: item.name
        });**/
    sql += "WHERE 1 = 1 ";
    console.log("filters", filters);
    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];
      sql += " AND " + filter.field + "" + filter.operator + "'" + filter.value + "' ";
    }

    sql += group ? "GROUP BY " + group : "";

    //console.log("calling sql " + sql);

    chart.dataSource = await chartDataSource.item.request({
      sql: sql,
      id: item.queryParameters.id
    });
    //console.log(sql);
    console.log("chart.dataSource", chart.dataSource);
    console.log("chart.subHeaders", chart.subHeaders);
    aggregateData(chart.dataSource.filteredData, chart.subHeaders);
    console.log("chart.subHeaders", chart.subHeaders);
    //console.log("after load chart.activeItem", chart.activeItem);
  }

  function getAggregatableHeaders(headers) {
    let aggregatableHeaders = [];
    for (let i = 0; i < headers.length; i++) {
      let header = headers[i];
      header.showFooter = false;
      header.tableCellClass = "column text-xs-left";
      if (header.show == true && header.type.type == "numeric" && header.aggregate) {
        header.total = 0;
        header.showFooter = true;
        header.tableCellClass = "column text-xs-right";
        aggregatableHeaders.push(header);
      }
    }
    return aggregatableHeaders;
  }

  function aggregateRow(row, headers) {
    for (let i = 0; i < headers.length; i++) {
      let header = headers[i];
      if (typeof row[header.value] != "undefined") {
        header.total += row[header.value];
      }
    }
  }

  function aggregateData(list, headers) {
    let aggregatableHeaders = getAggregatableHeaders(headers);

    for (let i = 0; i < list.length; i++) {
      let row = list[i];
      aggregateRow(row, aggregatableHeaders);
    }
  }

  chart.reloadItem = async function (itemAggregate) {

    console.log("itemAggregate", itemAggregate);
    if (isDateTransformation(itemAggregate) == true) {
      // console.log("yes isDateTransformation");
      // chart.activeItem.options.xaxis.type = 'datetime';
      // chart.activeItem.options = {...chart.activeItem.options, ...{xaxis: {type: 'datetime'}}};
    } else if (chart.activeItem.options.xaxis.type == "datetime") {
      // chart.activeItem.options = {...chart.activeItem.options, ...{xaxis: {type: 'category'}}};
    }
    // console.log("chart.activeItem", chart.activeItem);
    let query = {};
    query.id = chartDataSource.item.id;
    let qParameters = chart.activeItem.queryParameters;
    let itt = itemAggregate.format.replace("field", qParameters.itemField);
    let filters = [...queryParameters.filters];
    filters.push({
      field: chart.activeItem.queryParameters.group,
      operator: '=',
      value: chart.activeItem.name
    });

    query.sql = createSQL(qParameters.fullQuery, qParameters.group, itt, qParameters.value, qParameters.filters, qParameters.transformValue, customFilter);
    // console.log("query", query);
    let dd = await chartDataSource.item.request(query);
    chart.response = dd;


    let series = createSeries(dd.data, 'name', 'x', 'y', itemTransformItem);
    // console.log("series", series);
    let fSeries = series[0];
    // fSeries.selectedItem = chart.activeItem.selectedItem;
    // fSeries.queryParameters = chart.activeItem.queryParameters;
    chart.activeItem.data = [...fSeries.data];
    console.log(chart.activeItem.data);
    chart.activeItem.queryParameters.item = itt;
    //chart.chartData.subSeries = [];
    //chart.chartData.subSeries.push(chart.activeItem);

    // console.log("chart.chartData.subSeries", chart.chartData.subSeries);
    // chart.chartData.subSeries.push(chart.activeItem);

    // console.log("chart.activeItem.data", chart.activeItem.data);
    // console.log("calling hydrator 7 " + chart.id);

    // let dd = await chartDataSource.item.request(query);
  }


  // chart.chartData.subSeries = [];
  chart.setActiveItem = async function (item) {
    if (chart.dialog != true) {
      // chart.dialog = true;
    }
    if (typeof chart.openDialog != "undefined") {
      console.log("openDialog", chart.id);
      chart.openDialog();
    }


    // console.log("setActiveItem", item);
    chart.dataSource = null;
    chart.activeItem = null;

    chart.activeItem = { ...item };
    chart.activeItem.options = { ...options };


    // return;
    chart.activeItem.options.title = { text: undefined };
    chart.activeItem.options.subtitle = { text: undefined };



    if (isDateTransformation(chart.activeItem.queryParameters.item) == true) {
      // console.log("yes isDateTransformation");
      // chart.activeItem.options.xaxis.type = 'datetime';
      //chart.activeItem.options = {...chart.activeItem.options, ...{xaxis: {type: 'datetime'}}};
    } else if (chart.activeItem.options.xaxis.type == "datetime") {
      //chart.activeItem.options = {...chart.activeItem.options, ...{xaxis: {type: 'category'}}};
    }



    if (typeof item.color != "undefined") {
      chart.activeItem.options.colors = [item.color];
    }

    chart.activeItem.options.chart.events.dataPointSelection = function (event, chartContext, config) {

      let iItem = chart.activeItem.data[config.dataPointIndex];
      let filters = [...chart.subFilters];
      filters.push({
        field: chart.activeItem.queryParameters.item,
        operator: '=',
        value: iItem.x
      });
      // console.log("iItem", iItem);
      // console.log("filters", filters);
      chart.loadActiveItem(filters);

    }
    let sql = "SELECT * FROM (" + item.queryParameters.fullQuery + ") AS _subQuery ";
    let filters = [...item.queryParameters.filters];
    sql += "WHERE 1 = 1 ";
    filters.push({
      field: item.queryParameters.group,
      operator: '=',
      value: item.name
    });
    chart.subFilters = [...filters];

    // console.log("item.queryParameters", item.queryParameters);
    filters.push({
      field: item.queryParameters.item,
      operator: '=',
      value: item.selectedItem.x
    });

    filters = removeDuplicates(filters, 'field');
    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];
      sql += " AND " + filter.field + "" + filter.operator + "'" + filter.value + "' ";
    }

    sql = item.queryParameters.fullQuery + " LIMIT 1";


    const dataSource = await chartDataSource.item.request({
      sql: sql,
      id: item.queryParameters.id
    });
    chart.subHeaders = [];



    chart.chartData.dateTransformation = chart.activeItem.queryParameters.itemTransformItem;

    setHeaders(dataSource.headers);
    chart.loadActiveItem(filters);
    // chart.reload(chart.activeItem.queryParameters.item);
    // console.log("chart.dialog", chart.dialog);

  }
  function setHeaders(fullHeaders) {
    // chart.subHeaders
    // console.log("1. parameters.selectedColumns.value", parameters.selectedColumns.value);
    let h = [];
    let subHeaders = [...fullHeaders];
    try {
      h = JSON.parse(parameters.selectedColumns.value);
    } catch (err) {

    }
    if (!Array.isArray(h)) {
      h = [];
    }
    //console.log("hello", h);
    //  subHeaders = [...fullHeaders];
    let r = [];

    for (let i = 0; i < subHeaders.length; i++) {
      let item = subHeaders[i];
      // subHeaders.forEach((item, i) => {
      item.menu = false;
      item.aggregate = null;
      item.position = i;
      if (typeof item.selected == "undefined") {
        item.selected = true;
      }

      const found = h.find(function (element) { return element.value == item.value; });

      item.selected = found && typeof found.selected != "undefined" ? found.selected : item.selected;
      item.aggregate = found && typeof found.aggregate != "undefined" ? found.aggregate : item.aggregate;

      if (found && typeof found.position != "undefined" && found.position != item.position) {
        //  console.log("item position", item.value + ":" + item.position);
        // console.log("found position", item.value + ":" + found.position);
      }
      item.position = found && typeof found.position != "undefined" ? found.position : item.position;
      // console.log("item 2 position", item.value + ":" + item.position);
      if (found) {

      }

      subHeaders[i] = item;
      r.push({ ...item });

    }
    r = r.sort(function (a, b) { return a.position - b.position });
    r.forEach(it => {
      if (it.value == "year") {
        //   console.log("year item", it);
      }
    })
    chart.subHeaders = [];
    chart.subHeaders = [...r];
    // console.log("sorted position subHeaders", r);
  }



  options.chart.id = chart.id;
  options.dataLabels = {
    enabled: false
  };
  options.plotOptions = {};
  options.title = { text: undefined };
  options.subtitle = { text: undefined };
  options.subTitle = {};

  /**
  options.colors = ['#C1BEC7', '#FF0814', '#151821', '#857A89', '#F54355'];
  // options.colors = ['#FA8F13', '#EE2C1F', '#6A7785', '#283BD1', '#454E5D'];
  options.colors = ['#003f5c', '#58508d', '#bc5090', '#ff6361', '#ffa600'];
  // console.log("parameters.colorGradient", parameters.colorGradient);
  if (typeof parameters.colorGradient.item.id != "undefined" && parameters.colorGradient.item.id) {
    // options.colors = parameters.colorGradient.item.color.split(":");
  }
  if(chart.type == "heatmap.apexchart") {
    options.colors = [options.colors[0]];
    options.colors = ["#008FFB"];

  }**/
  options.yaxis = {
    title: { text: undefined },
    labels: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      formatter: function (value) {
        if (isNaN(value)) {
          return value;
        }
        return nFormatter(value, 2);
      }
    }
  };

  //console.log("calling hydrator 4 " + chart.id);

  options.xaxis = {
    title: { text: undefined },
    labels: {
      show: true,
      offsetX: 0,
      offsetY: 0
    },
    axisBorder: {
      show: true,
      color: '#78909C',
      height: 1,
      width: '100%',
      offsetX: 0,
      offsetY: 0
    },
    axisTicks: {
      show: true,
      borderType: 'solid',
      color: '#78909C',
      height: 6,
      offsetX: 0,
      offsetY: 0
    }
  };

  options.legend = {
    show: resolve("showLegendSource.value", parameters),
    position: resolve("legendPositionData.value", parameters)
  };

  const gridHeight = chart.grid.h;
  const layoutHeight = chart.grid.layout.rowHeight;
  const realHeight = (layoutHeight * gridHeight);
  data.height = realHeight;

  // console.log("layoutHeight", layoutHeight);
  // console.log("gridHeight", gridHeight);
  // console.log("realHeight", realHeight);
  // console.log("grid", chart.grid);
  /***
    options.legend = {};
    options.legend.show = false;

    options.xaxis = {};
    options.xaxis.labels = {};
    options.xaxis.labels.show = false;
**/
  //  options.yaxis = {title: {text: undefined}};
  //  options.yaxis.labels = {};

  //  options.yaxis.labels.show = false;



  // data.options = {...options};

  let chartDataSource = parameters.chartDataSource;

  let items = parameters.chartDataSource.items;

  //console.log("calling hydrator 5 " + chart.id);

  for (let i = 0; i < items.length; i++) {
    await items[i].update(true);
    // console.log("chartDataSource", items[i]);
  }

  if (!chartDataSource.item.data.length && items.length) {
    chartDataSource.item = items[0];
    chartDataSource.value = items[0].id;
  }
  // console.log("chartDataSource.item.headers", chartDataSource.item.headers);
  chartDataSource.item.headers.forEach(function (t) {
    // console.log(t.text + " : " + t.type.type + " : " + t.type.points);
  });

  //  console.log("chartDataSource.item.fullQuery", chartDataSource.item.fullQuery);


  let query = {};
  let fullQuery = chartDataSource.item.fullQuery;
  query.id = chartDataSource.item.id;
  // "strftime('%Y %m', `date`)"

  let _group = resolve("groupData.value", parameters);
  let customFilter = resolve("customFilter.value", parameters);



  let _item = resolve("itemData.value", parameters);
  let _transformItem = resolve("transformItemData.value", parameters);

  let itemTransformItem = pickItem(parameters.transformItemData);
  options.xaxis.type = 'category';

  options.chart.toolbar = {
    show: true,
    tools: {
      download: true,
      selection: true,
      zoom: true,
      zoomin: true,
      zoomout: true,
      pan: true,
      reset: true,
      customIcons: []
    },
    autoSelected: 'zoom'
  };

  //

  //console.log("itemTransformItem", itemTransformItem);

  let _value = resolve("valueData.value", parameters);
  let _transformValue = resolve("transformValueData.value", parameters);
  let _titleValue = resolve("content.value", parameters);

  options.title.text = resolve("title.value", parameters, undefined);
  options.subtitle.text = resolve("subtitle.value", parameters, undefined);

  options.xaxis.title.text = resolve("itemTitle.value", parameters, undefined);
  options.yaxis.title.text = resolve("valueTitle.value", parameters, undefined);
  if (!options.xaxis.title.text) {
    options.xaxis.title.text = undefined;
  }
  if (!options.yaxis.title.text) {
    options.yaxis.title.text = undefined;
  }


  _group = _group ? _group : null;
  _item = _item ? _item : _group;

  _group = _group ? _group : null;
  _item = _item ? _item : null;

  let itemField = _item;

  const itemTransformText = getItemText(parameters, "transformItemData", _transformItem);
  const valueText = getItemText(parameters, "valueData", _value);
  const groupText = getItemText(parameters, "groupData", _group);

  if (itemTransformText && _titleValue == "<h2>Title</h2>") {
    // parameters.content.value = "<h2>" + itemTransformText + " " + pluralize.plural(valueText) + " By " + groupText + "</h2>";
  }
  // let title = itemTransformText + " " + pluralize.plural(valueText) + " By " + groupText;
  // console.log("title", title);

  if (_item) {
    _item = _transformItem.replace("field", _item);
  }

  if (_value) {
    _value = _transformValue.replace("field", _value);
  }


  //console.log("calling hydrator 6 " + chart.id);

  // console.log("parameters", parameters);
  //  console.log("_item", _item);
  //console.log("_value", _value)

  let _filters = resolve("tree.filters", chart);
  //  console.log(_filters);
  let filters = _filters ? Object.values(_filters) : [];

  let sqlFilter = createFilter(chart, parameters);

  query.sql = createSQL(fullQuery, _group, _item, _value, filters, _transformValue, sqlFilter);
  //console.log("query", query);
  //  console.log("calling hydrator 7 " + chart.id);

  let dd = await chartDataSource.item.request(query);
  chart.response = dd;

  if (isDateTransformation(itemTransformItem) == true) {
    options.xaxis.type = 'datetime';
  }


  // console.log("dd.data", dd.data);


  if (dd.data.length > 10000) {
    return false;
  }


  // console.log('chartDataSource.item', chartDataSource.item);
  // data = {...data,  ...{series: createSeries(chartDataSource.item.data)}};
  let series = createSeries(dd.data, 'name', 'x', 'y', itemTransformItem);
  let extractedColors = extractColors(resolve("colors.value", parameters));

  options.colors = getSeriesColors(extractedColors, series);
  // console.log("series", series);

  // Object.freeze(series);
  // _group, _item, _value, filters, _transformValue
  let queryParameters = {
    id: chartDataSource.item.id,
    fullQuery: fullQuery,
    filters: filters,
    group: _group,
    item: _item,
    value: _value,
    itemField: itemField,
    transformValue: _transformValue,
    dialog: false,
    itemTransformItem: itemTransformItem
  };

  series.forEach(function (row) {
    row.queryParameters = queryParameters;
  });

  data.itemTransform = itemTransformItem;
  // console.log("transformed series", JSON.stringify(series));
  // options.series = series;
  let annotations = { yaxis: [], xaxis: [], points: [] };

  const transFormDate = isDateTransformation(itemTransformItem);

  // highestModel(series, annotations, transFormDate);
  // averageModel(series, annotations, transFormDate);
  // missingValuesModel(series, annotations, transFormDate);

  options.annotations = annotations;


  // console.log('series');
  // console.log(series);

  options.animations = {
    enabled: true,
    easing: 'easeinout',
    //speed: 800,
    animateGradually: {
      enabled: true,
      //  delay: 150
    },
    dynamicAnimation: {
      enabled: true,
      //  speed: 350
    }
  };


  // console.log("chart type", chart.type);
  if (chart.type == "bar.apexchart") {
    const horizontalSource = resolve("horizontalSource.value", parameters);
    const stackedSource = resolve("stackedSource.value", parameters);
    options.plotOptions.bar = { horizontal: horizontalSource };
    options.chart.stacked = stackedSource;
  }




  if (series.length) {
    data.options = { ...options };
    data.series = [...series];
    console.log("chart.type", chart.type);
    console.log("series", series);

    /**

//  console.log("data.options", data.options);
  data.valid = true;
  if (typeof chart.instance != 'undefined' && chart.instance) {
    // console.log('chart.instance', 'exist');
    //
    // chart.instance.updateSeries(series, false, true);
    chart.instance.updateOptions(options, true, true);
    //console.log('series', series);
    // chart.instance.refresh();
    // console.log('chart.instance', chart.instance);
  } else {
    //  console.log('chart.instance', 'not set');
  }
  **/
  }

  // console.log("calling hydrator 8 " + chart.id);

}
